import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { DefaultRequest } from '../requests/default.request';
import { Menu, MenuDish, SecondMenu, HistoryData, BusinessMenu, TableStatus } from '../constants/type.constant';
import Store from '../redux/store';
import 'swiper/swiper.min.css';
import '../resources/css/menu.scss';
import { WebsocketClient } from '../websocket/module';
import IconButton from '@material-ui/core/IconButton';

// Message Modal
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../messenger/module';

import { TableStatusEventObject, UpdateDishEventObject, UpdateSelectMenuEventObject } from '../websocket/type';
import ShoppingCart from '../modules/shopping-cart';
import FoodDetail from '../components/food-detail.component';
import FoodNormal from '../components/food-normal.component';
import FoodTip from '../components/food-tip.component';
import _, { isArray } from 'lodash';
import { getSettingInfo } from '../tools/get-setting-info';
import { createHashHistory } from 'history';
import SelectCustomId from '../components/select-customId.component';
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
import { getCacheField } from '../tools/get-cache-field';
import { GuideTooltips } from '../components/tooltip.component';
import { isIphonex, PHONE_TYPE } from '../tools/utils';
import AutoSizer from 'react-virtualized-auto-sizer';
import List from 'react-virtualized/dist/commonjs/List';
import InfiniteLoader from 'react-virtualized/dist/commonjs/InfiniteLoader';
import BScroll from 'better-scroll';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { UpdateCart } from '../websocket/cart2';
import { getCurrentBusinessMenu, isNewBusiness, scheduleTransform } from '../constants/tools.constant';
import LeftBarDishItem from '../components/left-bar-dish-item.component';
import Skeleton from '../components/skeleton/skeleton.conponent';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import SetDishDetailItem from '../components/set-dish-detail-item.conponent';
import { MenuAllergenFilter } from '../components/allergens-filter/menu-allergen-filter.component';
import { CartModule } from '../modules/cart/module';
import { DetailMessageObject } from '../messenger/type';

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

class MenuPage extends Component<Props, State> {
    public messengerModule: MessengerModule;
    public swiperCardViewUpdate = false;
    public scrollCount = 0;
    public scrollTimeOut!: NodeJS.Timeout;
    public idClickMenuMode: boolean = false;
    public AutoSizerRef: List | null = null;
    public _timeoutIdMap: any = {};
    public SlideScroll: BScroll | undefined;
    public InfiniteLoaderKey: string = '';
    // 滚动lock
    public scrollLock: boolean = false;
    // 菜单高度
    public MenuListHeight: number = window.innerHeight - 72 - 47 - 30;
    // 货币文本
    public currency_name: string = '€';
    // 菜名显示
    public showMenuItemType: boolean = _.get(getSettingInfo('show-item-name1-or-item-name2', 'value'), 'showItemName1', true);
    // 缓存中的桌台状态
    public tableStatusById: TableStatus[] = [];
    // 手机型号判断
    public _isIphonex = false;

    // 菜品列表dom
    public ListRef: HTMLDivElement | null = null;
    // 手势起始位置记录
    public startY: number = 0;
    // 处于底部
    public isBottom: number = 0;
    // 存储底部
    public saveBottom: number = 0;
    // 处于顶部
    public isTop: number = 0;
    // 存储顶部
    public saveTop: number = 0;
    // 在顶部下拉次数
    public topNumber: number = -1;
    animateTimer:any = null;

    public state: State = {
        // 一级菜单
        firstLevelMenu: [],
        // 选中的一级菜单
        selectedFirstLevelMenu: Store.getState().selectedFirstLevelMenu,
        // 选中的一级菜单的二级菜单
        secondLevelMenu: [],
        // 选中的二级菜单的菜品
        menuDish: [],
        // 菜品显示模式
        menuDisplayMode: Store.getState().menuModeDefaultVal,
        // 一级菜单下拉箭头
        arrowDirection: 'DOWN',
        // 加载中
        loading: true,
        // 是否打开菜品大图
        foodDetailVisible: false,
        // 菜品大图轮播图索引
        initialSlide: 0,
        // 上一轮次已点数
        turnDishesNum: 0,
        // 记录每一轮的历史记录
        roundCustomerDishData: {},
        updateToolTipStatus: this.getUpdateToolStatus(),
        // 所有一级菜单下的菜品
        dishesList: [],
        // 所有二级菜单数据（瀑布流模式）
        secondLevelMenuData: [],
        // 菜品列表title高度数组
        listHeight: [],
        // 滚动加载
        loadedRowsMap: {},
        // 选中二级菜单的位置
        recordMenuIndex: 0,
        // 是否显示套餐详情弹窗
        setDishItemVisible: false,
        // 选择的套餐
        selectedSetDishItem: undefined,
        scrollLoading: 0,
        // 
        isAnimateFlag: false,
    };

    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this._rowRenderer = this._rowRenderer.bind(this);
        this._onScroll = this._onScroll.bind(this);

        this._isRowLoaded = this._isRowLoaded.bind(this);
        this._loadMoreRows = this._loadMoreRows.bind(this);
        this._timeoutIdMap = {};
        this.currency_name = StateManager.getFromCache('currency_name') || '€';
        this._isIphonex = isIphonex();
    };
    public getUpdateToolStatus() {
        const { customer } = this.props;
        if (getCacheField('approvalStatus') === 'NO' && customer.length === 0) {
            return false;
        }
        return getCacheField('guidePageHideDishes') ? true : false
    }
    // 轮次
    public ROUND: number = parseInt(getCacheField('turnInfo.rule_gnr_turn') || '0');

    // *********************
    // 生命周期
    // *********************
    public async UNSAFE_componentWillMount() {
        if (!this.props.liteMode) {
            // $ 接收 其他顾客发送的桌台状态通知 ,
            WebsocketClient.addListener('TABLE_STATUS', this.tableStatusListener);
            // $ 监听更新购物车
            WebsocketClient.addListener('UPDATE_CART', this.updateCartListener);
            // $ 监听退菜
            WebsocketClient.addListener('RETURN_DISHES', this.updateCartListener);
        }
        // 更新缓存中的图片加载随机数参数
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'imgRandomNumberParam',
            value: Math.random() * 100000,
        });
    }
    public async componentDidMount() {
        this.tableStatusById = StateManager.getFromCache('tableStatusById');
        await this.initDishRules();
        this.getMenuListheight();
        this.getRestaurantInfo();
        // $ 普通版模式下，才需要基本的点餐操作
        if (!this.props.liteMode) {
            getCacheField('approvalStatus') === 'NO' && await this.getOrderTurn();
            //购物车没有任何东西的时候初始化数据 同步远程数据
            // ShoppingCart.getRemoteHistory();
            // Store.dispatch({
            //     type: 'SYNCHRONIZE',
            //     direction: 'CACHING_TO_STATE',
            // })

            // $ 接收 其他顾客清空购物车的通知（弃用）
            // WebsocketClient.addListener('DELETE_DISH', this.delectDishListener);

            // $ 监听其他设备操作时，更新菜品卡片数据（要求同一个用户）
            // WebsocketClient.addListener('ADD_DISH_COUNT', this.addDishConutListener);
            // WebsocketClient.addListener('REMOVE_DISH_COUNT', this.removeDishConutListener);
            // $ 监听顾客选择ID后更新
            WebsocketClient.addListener('UPDATE_DISH', this.updateSeletedIdListener);
            // $ 菜品提交锁，防止用户同时提交或者操作菜品出现的购物车异常
            // WebsocketClient.addListener('ADD_COMMIT_LOCK', this.commitLockListener);
            // WebsocketClient.addListener('REMOVE_COMMIT_LOCK', this.removeCommitLockListener);
            // $ 分配顾客ID后
            WebsocketClient.addListener('BUBBLE_PROMPT', this.toolTipListener)
            // $ 所有菜单获取完毕
            WebsocketClient.addListener('IS_UPDATE_MENU', this.updateMenu)


        }
    }


    // 监听用户选中ID
    public toolTipListener = async () => {
        this.setState({ updateToolTipStatus: true })
    }
    // $ 销毁监听
    public async componentWillUnmount() {

        // $ alwyas unsubscribe in un mount function
        this.setState = (state, callback) => { return; };
        WebsocketClient.removeListener('TABLE_STATUS', this.tableStatusListener);
        WebsocketClient.removeListener('UPDATE_DISH', this.updateSeletedIdListener);
        // WebsocketClient.removeListener('ADD_COMMIT_LOCK', this.commitLockListener);
        // WebsocketClient.removeListener('REMOVE_COMMIT_LOCK', this.removeCommitLockListener);
        // WebsocketClient.removeListener('ADD_DISH_COUNT', this.addDishConutListener);
        // WebsocketClient.removeListener('REMOVE_DISH_COUNT', this.removeDishConutListener);
        // WebsocketClient.removeListener('DISTRIBUTION_ID', this.toolTipListener);
        WebsocketClient.removeListener('IS_UPDATE_MENU', this.updateMenu);
        // WebsocketClient.removeListener('DELETE_DISH', this.delectDishListener)
        WebsocketClient.removeListener('UPDATE_CART', this.updateCartListener);
        WebsocketClient.removeListener('RETURN_DISHES', this.updateCartListener);
        document.removeEventListener('scroll', this.scrollView);
        Object.keys(this._timeoutIdMap).forEach((timeoutId: any) => {
            timeoutId && clearTimeout(timeoutId);
        });
    }

    // *********************
    // 方法区
    // *********************
    /**
     * 获取餐馆信息
     */
    public async getRestaurantInfo() {
        const RESTAURANT = await DefaultRequest.getRestaurantInfo();
        if (Array.isArray(RESTAURANT)) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'currency_name',
                value: RESTAURANT?.[0]?.currency_name || '€',
            })
            this.currency_name = RESTAURANT?.[0]?.currency_name || '€'
        }
    }
    /**
     * 获取菜单高度并重置菜单列表
     */
    getMenuListheight() {
        // 设置菜单高度（虚拟列表）
        this.MenuListHeight = window.innerHeight - 50 - 30 - (this.state.menuDisplayMode === 'CAROUSEL' ? 0 : 47);
        this.AutoSizerRef?.recomputeGridSize();
    }
    /**
     *  $ 所有菜单获取完毕
     */
    public updateMenu = (data?: UpdateSelectMenuEventObject) => {
        // $ COP 主动修改选择的菜品 data.project === 'COP'
        this.getMenus(data && data.project === 'COP');
    }
    // $ 监听更新购物车
    public updateCartListener = (data: UpdateCart) => {
        console.log(data, '监听 更新购物车-menu--UPDATE_CART');
        if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
            ServerShoppingCart.updateSeverShoppingCartModule(data.data);
            this.setState({
                secondLevelMenu: this.initDish(this.state.secondLevelMenu)
            })
        }
    }
    // 监听用户删除购物车
    // private delectDishListener = (data: DeleteDishEventObject) => {
    //     if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
    //         this.state.menuDish.forEach((item) => {
    //             item.quantity = 0;
    //             delete item.dishesLock
    //         })
    //         this.setState({ menuDish: this.state.menuDish })
    //     }
    // }

    // /**
    //  *  $ 监听通讯事件 （弃用）
    //  *  更新菜品卡片数据
    //  */
    // public addDishConutListener = (data: AddDishCountEventObject) => {
    //     this.state.menuDish.forEach((item) => {
    //         if (item.item_id === data.dishes.item_id && data.customer === this.props.customer) {
    //             item.quantity = data.reportCount.familyDishTotalCount;
    //             // item.history_num = _.get(data.dishes, 'history_num') || 0;
    //         }
    //     })
    // }
    // public removeDishConutListener = (data: AddDishCountEventObject) => {
    //     this.state.menuDish.forEach((item) => {
    //         if (item.item_id === data.dishes.item_id && data.customer === this.props.customer) {
    //             item.quantity = data.reportCount.familyDishTotalCount;
    //             // item.history_num = _.get(data.dishes, 'history_num') || 0;
    //         }
    //     })
    // }
    // $ 监听顾客选择ID后更新
    public updateSeletedIdListener = (data: UpdateDishEventObject) => {
        // const customerCart: CartDish[] = _.get(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${data.customer}`);
        // if (customerCart) {
        //     customerCart.forEach((item) => {
        //         _.find(this.state.menuDish, (n) => {
        //             if (n.item_id === item._origin.item_id) {
        //                 n.quantity = item.count + item.excessCount
        //             }
        //         })
        //     });
        // }
        this.setState({
            secondLevelMenu: this.initDish(this.state.secondLevelMenu)
        })
    }

    // 监听桌台状态通知
    public tableStatusListener = (data: TableStatusEventObject) => {

        const { orderRequestMsg, resendOrderSecond } = data;
        // 开台请求的信息
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderRequestMsg',
            value: orderRequestMsg
        })
        // 开台信息
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderTab',
            value: {
                person: orderRequestMsg.person ? orderRequestMsg.person : orderRequestMsg.childNum + orderRequestMsg.adultNum + Number(orderRequestMsg.otherNum),
                orderId: getCacheField('orderTab.orderId'),
                menuList: orderRequestMsg.menu,
                customer: getCacheField('orderTab.customer'),
                childNum: orderRequestMsg.childNum,
                otherNum: orderRequestMsg.otherNum,
                normalNum: orderRequestMsg.adultNum,
            }
        })
        // 重新发送按钮倒计时
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'resendOrderSecond',
            value: resendOrderSecond,
        })
    }

    // 监听用户操作 防止其中一个用户提交购物车时 另一个用户菜品菜品导致的数据异常
    // commitLockListener = (data: AddCommitLockEventObject) => {
    // this.messengerModule.say({
    //     message: `${i18n.t('order_cart_page_text_is_submitting')}`,
    //     level: 'Warning'
    // })
    // this.setState({
    //     loading: true,
    // })
    // }
    // removeCommitLockListener = async (data: RemoveCommitLockEventObject) => {
    //     try {
    //         if (data.isMessage) {
    //             this.messengerModule.say({
    //                 message: `${i18n.t('order_cart_page_text_cannot_at_the_same_time')}`,
    //                 level: 'Error'
    //             })
    //         }
    //         const cartHistory = await DefaultRequest.getHistoryDish(
    //             getCacheField('orderTab.orderId'),
    //             Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9,
    //             'round'
    //         )
    //         this.setState({
    //             roundCustomerDishData: cartHistory.round_customer_dish_data
    //         })
    //         this.getMenuDish(this.state.menuDish)
    //         this.setState({
    //             loading: false,
    //         })
    //     } catch (error) {
    //         this.messengerModule.say({
    //             message: `${i18n.t('general_text_update_faild')}`,
    //             level: 'Warning',
    //         })
    //         this.setState({
    //             loading: false,
    //         })
    //     }
    // }

    /**
     * 控制二级菜单超额数量动画
     */
    public onControlLimitNumsAnimate = (isAnimate: boolean) => {
        this.setState({
            secondLevelMenu: this.initDish(this.state.secondLevelMenu),
            isAnimateFlag: isAnimate,
        })
        if(isAnimate) {
            if(this.animateTimer) clearTimeout(this.animateTimer);
            this.animateTimer = setTimeout(()=>{
               this.setState({
                 isAnimateFlag: false,
               })
            }, 500)
        }
    }

    // $ 初始化菜品相关规则
    public async initDishRules() {
        // 菜品基础规则参数

        try {
            let settingInfo = await DefaultRequest.getSettingInfo();
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
            const dishesSort = getSettingInfo('menu-dishes-sort', 'value');
            DefaultRequest.getMenus({ type: 0, dish_sort: dishesSort, with_dish: true, print: 1, extra: 1 });
            // 精简版模式只获取菜单数据
            if (this.props.liteMode) {
                // $ 初始化菜单显示模式
                const menuModeDefault = _.find(settingInfo, (n) => {
                    return n.id === 107
                })
                if (menuModeDefault) {
                    this.setState({
                        menuDisplayMode: menuModeDefault.value ? 'NORMAL' : 'CAROUSEL'
                    })
                }
                // 获取全部菜单数据
                this.getLiteMenus();
            } else {
                const cartHistory = await DefaultRequest.getHistoryDish(
                    getCacheField('orderTab.orderId'),
                    Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9,
                    'round,dish,type,rule'
                )
                // $ 初始化菜单显示模式
                const menuModeDefault = _.find(settingInfo, (n) => {
                    return n.id === 107
                })
                const menuDisplayMode = menuModeDefault && menuModeDefault.value ? 'NORMAL' : 'CAROUSEL';
                // if (menuModeDefault) {
                //     this.setState({
                //         menuDisplayMode: menuModeDefault.value ? 'NORMAL' : 'CAROUSEL'
                //     }, () => {
                //         if (this.state.menuDisplayMode === 'CAROUSEL') {
                //             Store.dispatch({
                //                 type: 'SET',
                //                 path: 'foodBarMode',
                //                 value: 'MULTIPLE'
                //             })
                //         } else {
                //             // this.changeFoodBarMode()
                //             let menuTop = document.getElementById('menuTop') || { scrollTop: 0 };
                //             menuTop.scrollTop = 0;
                //         }
                //     })
                // }

                if (menuDisplayMode === 'CAROUSEL') {
                    Store.dispatch({
                        type: 'SET',
                        path: 'foodBarMode',
                        value: 'MULTIPLE'
                    })
                } else {
                    // this.changeFoodBarMode()
                    let menuTop = document.getElementById('menuTop') || { scrollTop: 0 };
                    menuTop.scrollTop = 0;
                }

                // $ 更新购物车历史菜品数据
                ShoppingCart.historyDishNumMetaData = cartHistory.dish_round_customer_data
                ShoppingCart.historyDishRulesMetaData = cartHistory.dishRuleData;
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'roundCustomerDishData',
                    value: cartHistory.round_customer_dish_data
                })
                this.setState({
                    roundCustomerDishData: cartHistory.round_customer_dish_data,
                    menuDisplayMode,
                })

                // we check if already has a account4
                // 点餐最大回合数
                ShoppingCart.globalRoundMax = settingInfo[3].value

                // 更新订单信息
                if (!settingInfo[8].value.status) {
                    Store.dispatch({
                        type: 'SET',
                        path: 'orderTab.customer',
                        value: '1'
                    })
                }
                // 获取全部菜单数据
                this.getMenus(true);
            }

        } catch (error) {
            this.setState({
                loading: false,
            })
            this.messengerModule.say({
                message: `${i18n.t('general_text_update_faild')}`,
                level: 'Warning',
            });
        }
    }

    public async getOrderTurn() {
        try {
            // 轮次规则
            const ORDERID = StateManager.getFromCache('orderTab.orderId');
            let turnInfo = await DefaultRequest.getTurnInfo(
                ORDERID,
                Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9
            );

            this.ROUND = parseInt(getCacheField('turnInfo.rule_gnr_turn') || '0');

            ShoppingCart.historyCategoryDishLimit = turnInfo.slu_dishes_number;
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'turnInfo',
                value: turnInfo,
            });

        } catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('general_text_get_limit_rule_failed')}`,
                level: 'Error'
            })
        }
    }
    /**
     * 获取全部菜单数据
     * @param updateDefult // $ COP 主动修改选择的菜品 data.project === 'COP'
     */
    getMenus = async (updateDefult?: boolean) => {
        try {
            // 菜单菜品排序设置
            const dishesSort = getSettingInfo('menu-dishes-sort', 'value');
            // 根据桌台id获取当前桌台状态
            let resultTableStatus = StateManager.getFromCache('tableStatusById');
            if (_.isEmpty(resultTableStatus) || updateDefult) {
                resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
            }
            let cacheSelectMenu = `${getCacheField('orderTab.menuList.main_group_id') || ''}`;
            // $ 联合COP 开台存在多个选择的菜单
            let select_menu = resultTableStatus?.[0]?.select_menu || cacheSelectMenu;
            // 开台选择的菜单存在
            if (select_menu) {
                const select_menu_arr = select_menu?.split(',');
                const new_select_menu = select_menu_arr.filter((f: any) => { return !!f }).map((n: any) => Number(n));
                // 用户第一次进入时的菜单处理
                // if (updateDefult || !Store.getState().cacheMenus.length) {
                if (updateDefult) {
                    // let ALL_MENU = await DefaultRequest.getFirstMenuName();
                    let ALL_MENU = await DefaultRequest.getMenus({
                        type: 0,
                        with_dish: false,
                        not_set_caching: true,
                    });
                    // 必选菜单
                    let defaultMenu: number[] = [];
                    defaultMenu = _.concat(new_select_menu, defaultMenu);
                    defaultMenu = _.uniq(defaultMenu);
                    // id 从小至大排序
                    defaultMenu.sort((a, b) => a - b);
                    // 显示的菜单=必选菜单+首页选择的菜单
                    let firstLevelMenu: Array<Menu> = [];
                    let { selectedFirstLevelMenu, secondLevelMenu, menuDish } = this.state;
                    ALL_MENU.forEach((resultItem: Menu) => {
                        defaultMenu.forEach((defaultMenuItem: number) => {
                            // 显示的一级菜单
                            if (defaultMenuItem === resultItem.main_group_id) {
                                firstLevelMenu.push(resultItem);
                            }
                        })
                    });
                    // 显示第一个菜单
                    let first_select_menu = firstLevelMenu?.[0].main_group_id;
                    let firstMenuResult = await DefaultRequest.getMenusItem(first_select_menu, dishesSort);
                    firstMenuResult.forEach((resultItem: Menu) => {
                        // 选中的一级菜单
                        if (first_select_menu === resultItem.main_group_id) {
                            // 选中的一级菜单
                            selectedFirstLevelMenu = resultItem;
                            // 选中的二级菜单
                            secondLevelMenu = resultItem.menu_item_slu;
                            // 获取选中的二级菜单的菜品的图片
                            menuDish = this.getMenuDish(resultItem.menu_item_slu[this.state.recordMenuIndex].menu_item).menuDish;
                            return
                        }
                    })
                    Store.dispatch({
                        type: 'SET',
                        path: 'selectedFirstLevelMenu',
                        value: selectedFirstLevelMenu
                    })
                    this.setState({
                        // 一级菜单
                        firstLevelMenu,
                        // 选中的一级菜单
                        selectedFirstLevelMenu,
                        // 选中的一级菜单的二级菜单
                        secondLevelMenu: this.initDish(secondLevelMenu),
                        // 选中的二级菜单的菜品
                        menuDish,
                        loading: false,
                    }, () => {
                        this.getHeightList();
                        if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                            WebsocketClient.emit('BUBBLE_PROMPT')
                        }
                    })
                }
                else {
                    this.setState({
                        loading: false,
                    })
                }
                // // 菜单菜品缓存完成的处理
                // else {
                //     await this.menuDishProcessing(Store.getState().cacheMenus, new_select_menu)
                // }
            } else {
                this.messengerModule.say({
                    message: `${i18n.t('home_page_text_please_select_menu')}`,
                    level: 'Warning',
                });
                createHashHistory().push({ pathname: '/Home' });
            }
        }
        catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('home_page_text_get_menu_fail')}`,
                level: 'Warning',
            });
            this.setState({
                loading: false,
            })
        }
    }

    getLiteMenus = async () => {
        try {
            const dishesSort = getSettingInfo('menu-dishes-sort', 'value');
            // 首页选择的菜单
            let resultTableStatus = this.tableStatusById;
            if (_.isEmpty(resultTableStatus)) {
                resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
            }
            let select_menu = parseInt(getCacheField('orderTab.menuList.main_group_id'));
            if (!select_menu) select_menu = parseInt(resultTableStatus[0].select_menu || '0');
            if (select_menu || this.props.liteMode) {
                // // 菜单菜品缓存完成的处理
                // if (Store.getState().cacheMenus.length) {
                //     // let result = Store.getState().cacheMenus;
                //     // const resultDishes = _.cloneDeep(result)
                //     this.menuDishProcessing(Store.getState().cacheMenus, select_menu)
                // }
                // // 用户第一次进入时的菜单处理
                // else {
                // $ lite菜单 统一处理,缓存中的菜单没有菜品
                // let ALL_MENU2 = await DefaultRequest.getFirstMenuName();
                let ALL_MENU = await DefaultRequest.getMenus({
                    type: 0,
                    with_dish: false,
                    not_set_caching: false,
                });
                // 必选菜单
                let defaultMenu = await this.getDefaultMenu();
                defaultMenu.unshift(select_menu);
                defaultMenu = _.uniq(defaultMenu);
                // filter no exist menu
                const allMenuIds = ALL_MENU.map(n => n.main_group_id);
                defaultMenu = defaultMenu.filter(fd => {
                    return allMenuIds.includes(fd);
                })
                // id 从小至大排序
                defaultMenu.sort((a, b) => a - b);
                // 显示的菜单=必选菜单+首页选择的菜单
                let firstLevelMenu: Array<Menu> = [];
                let { selectedFirstLevelMenu, secondLevelMenu, menuDish } = this.state;
                // 显示第一个菜单
                let first_select_menu = defaultMenu?.[0];
                let firstMenuResult = await DefaultRequest.getMenusItem(first_select_menu, dishesSort);
                defaultMenu.forEach((defaultMenuItem: number) => {
                    ALL_MENU.forEach((resultItem: Menu) => {
                        // 显示的一级菜单
                        if (defaultMenuItem === resultItem.main_group_id) {
                            if (first_select_menu === resultItem.main_group_id) {
                                firstLevelMenu.unshift(...firstMenuResult);
                            } else {
                                firstLevelMenu.push(resultItem);
                            }
                        }
                    })
                });
                firstMenuResult.forEach((resultItem: Menu) => {
                    // 选中的一级菜单
                    if (first_select_menu === resultItem.main_group_id) {
                        // 选中的一级菜单
                        selectedFirstLevelMenu = resultItem;
                        // 选中的二级菜单
                        secondLevelMenu = resultItem.menu_item_slu;
                        // 获取选中的二级菜单的菜品的图片
                        menuDish = this.getMenuDish(resultItem.menu_item_slu[this.state.recordMenuIndex].menu_item).menuDish;
                    }
                })
                this.setState({
                    // 一级菜单
                    firstLevelMenu,
                    // 选中的一级菜单
                    selectedFirstLevelMenu,
                    // 选中的一级菜单的二级菜单
                    secondLevelMenu: this.initDish(secondLevelMenu),
                    // 选中的二级菜单的菜品
                    menuDish,
                    loading: false,
                }, () => {
                    this.getHeightList();
                    if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                        WebsocketClient.emit('BUBBLE_PROMPT')
                    }
                })
            } else {
                this.messengerModule.say({
                    message: `${i18n.t('home_page_text_please_select_menu')}`,
                    level: 'Warning',
                });
                createHashHistory().push({ pathname: '/Home' });
            }
        }
        catch (error) {
            this.messengerModule.say({
                message: `${i18n.t('home_page_text_get_menu_fail')}`,
                level: 'Warning',
            });
            this.setState({
                loading: false,
            })
        }
    }

    /**
     * 菜单处理
     * @param resultDishes 缓存里的全部菜单
     * @param select_menu 开台选择的菜单
     */
    public async menuDishProcessing(resultDishes: Menu[], select_menu: number[] | number): Promise<void> {
        let first_select_menu: number = 0;
        // 必选菜单
        let defaultMenu: number[] = [];
        // 必选菜单
        if (typeof (select_menu) === 'object') {
            first_select_menu = select_menu?.[0];
            defaultMenu = _.concat(select_menu, defaultMenu);
        } else if (typeof (select_menu) === 'number') {
            first_select_menu = select_menu;
            defaultMenu.unshift(select_menu);
        }
        // 去重
        defaultMenu = _.uniq(defaultMenu);
        // 排序 从小至大
        defaultMenu.sort((a, b) => a - b);
        // 显示的菜单=必选菜单+首页选择的菜单
        let firstLevelMenu: Array<Menu> = [];
        let { selectedFirstLevelMenu, secondLevelMenu, menuDish } = this.state;
        let dishesList: Array<MenuDish> = [];
        const storeState = Store.getState() || {};
        if (resultDishes.length > 0) {
            const mainGroupID = _.get(storeState.selectedFirstLevelMenu, 'main_group_id');
            const findMenuGroupId = _.find(resultDishes, (item) => (item.main_group_id === mainGroupID)) && defaultMenu.includes(mainGroupID);
            defaultMenu.forEach((defaultMenuItem: number) => {
                resultDishes.forEach((resultItem: Menu) => {
                    // 显示的一级菜单
                    if (defaultMenuItem === resultItem.main_group_id) {
                        firstLevelMenu.push(resultItem);
                        // 基于首选菜单有可能不在点餐时间段，初始化一个菜单ID
                        if (mainGroupID) {
                            let newSelectedFirstLevelMenu = findMenuGroupId ? storeState.selectedFirstLevelMenu : resultItem;

                            selectedFirstLevelMenu = newSelectedFirstLevelMenu;
                            secondLevelMenu = _.get(newSelectedFirstLevelMenu, 'menu_item_slu');
                            const RECORD_MENUITEM = _.get(newSelectedFirstLevelMenu, `menu_item_slu.${this.state.recordMenuIndex}.menu_item`);
                            menuDish = this.getMenuDish(RECORD_MENUITEM).menuDish;
                        }
                    }
                })
            });
            resultDishes.forEach((resultItem: Menu) => {
                // 选中的一级菜单
                if (first_select_menu === resultItem.main_group_id) {
                    // 是否记录的上一次选中菜单
                    if (mainGroupID) {
                        let newSelectedFirstLevelMenu = findMenuGroupId ? storeState.selectedFirstLevelMenu : resultItem;

                        selectedFirstLevelMenu = newSelectedFirstLevelMenu;
                        secondLevelMenu = _.get(newSelectedFirstLevelMenu, 'menu_item_slu');
                        const RECORD_MENUITEM = _.get(newSelectedFirstLevelMenu, `menu_item_slu.${this.state.recordMenuIndex}.menu_item`);
                        menuDish = this.getMenuDish(RECORD_MENUITEM).menuDish;
                    } else {
                        // 选中的一级菜单
                        selectedFirstLevelMenu = resultItem;
                        // 选中的二级菜单
                        secondLevelMenu = resultItem.menu_item_slu;
                        // 获取选中的二级菜单的菜品的图片
                        menuDish = this.getMenuDish(resultItem.menu_item_slu[this.state.recordMenuIndex].menu_item).menuDish;
                    }
                }
            })
            this.setState({
                // 一级菜单
                firstLevelMenu,
                // 选中的一级菜单
                selectedFirstLevelMenu,
                // 选中的一级菜单的二级菜单
                secondLevelMenu: this.initDish(secondLevelMenu),
                // 选中的二级菜单的菜品
                menuDish,
                // 当前一级菜单下的所有菜品
                dishesList,
                loading: false,
            }, () => {
                // 初始化轮播图
                this.getHeightList();
                if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                    WebsocketClient.emit('BUBBLE_PROMPT')
                }
            })
        }
        else {
            this.setState({
                loading: false,
            })
        }
    }

    // 初始化菜品，添加参数(瀑布流，需要将二级菜单下的所有菜品添加必要参数，调味品..)
    initDish(secondLevelMenu: Array<SecondMenu>) {
        const round = getCacheField('advGlobalRound');
        const personArrs = getCacheField('personArr');
        secondLevelMenu.forEach((item) => {
            const { menuDish, menuOrderNums } = this.getMenuDish(item.menu_item, round);
            item.menu_item = menuDish.filter(temp => [0,3].includes(temp.item_type));
            item.customers_category_order_limit = (item.category_order_limit || 9999) * (Math.max(1, personArrs.length || 0));
            item.ordered_dishes_number = menuOrderNums;
        })
        console.log(secondLevelMenu,'cartError initDish')
        return secondLevelMenu;
    }

    /**
     * 更新菜品已选数量
     * @param menuDish
     * @returns
     */
    getMenuDish = (menuDish: Array<MenuDish & { history_num?: number }>, turnRound?: any) => {
        // const { roundCustomerDishData } = this.state;
        // const { customer } = this.props;
        // const round = turnRound ?? getCacheField('advGlobalRound');
        // $ 服务端购物车
        let currentCustomsItems = ServerShoppingCart.getCurrentCustomerCart({});
        let historyItems = ServerShoppingCart.metaData?.historyItems;
        let menuOrderNums: number = 0;
        // 历史购物车点的菜品（当前顾客）
        let historyDishItems = historyItems?.find((n) => { return _.has(n, 'ALL') })?.ALL;
        const showSellOutDishes = getSettingInfo('is_show_sell_out_dishes', 'value');
        if (showSellOutDishes === 0) {
            menuDish = menuDish.filter(item => item.bargain_stype === 0)
        }
        historyDishItems = historyDishItems?.filter((n) => { return n.userName === this.props.customer || ('RWA2_POS'.includes(n.project) && this.props.customer === '1') });
        menuDish.forEach((item) => {
            // 精简版不需要做以下操作
            if (!this.props.liteMode) {
                item.condiments = [];
                item.remarks = '';
                item.price_1 = _.round(item.price_1, 2);
                // 本轮历史记录的数量
                item.history_num = 0;
                // if (currentCustomsItems?.r3HistoryDishes) {
                //     currentCustomsItems?.r3HistoryDishes?.forEach((dishItem) => {
                //         if (`${dishItem.originId}` === `${item.item_id}`) {
                //             item.history_num = item.history_num ? dishItem.totalNum + item.history_num : dishItem.totalNum
                //         }
                //     })
                // }
                if (historyDishItems) {
                    let dishes = _.cloneDeep(historyDishItems).filter((dishItem) => { return `${dishItem.originId}` === `${item.item_id}` });
                    let totalNum = _.sumBy(dishes, (item) => { return item.totalNum }) || 0;
                    item.history_num = totalNum;
                }


                item.quantity = 0;
                let serverShoppingCartDishes = _.filter(currentCustomsItems?.dishes, (n) => { return `${item.item_id}` === `${n.originId}` });
                let allDishestotalNum = _.sumBy(serverShoppingCartDishes, (n) => { return n.totalNum });

                if (allDishestotalNum) {
                    item.quantity = allDishestotalNum;
                }
            }
            const totalQuantity = item.quantity + (item.history_num || 0);
            menuOrderNums += totalQuantity;
        });
        console.log(menuOrderNums,'getMenuDish')
        return {
            menuDish,
            menuOrderNums,
        };
    }

    // 点击一级菜单
    clickFirstLevelMenu = async (selectedFirstLevelMenu: Menu) => {
        let cachedFlag: boolean = false;
        if (_.isEmpty(selectedFirstLevelMenu.menu_item_slu)) {
            cachedFlag = false;
        } else {
            for (const slu of selectedFirstLevelMenu?.menu_item_slu) {
                if (Array.isArray(slu?.menu_item) && slu?.menu_item?.length > 0) {
                    cachedFlag = true;
                    break;
                }
                else {
                    continue;
                }
            }
        }
        /**
         * 预缓存菜单处理
         * 如果菜单缓存完成，直接走缓存的数据处理，
         * 否则，根据一级菜单id实时获取菜单数据
         */
        if (cachedFlag) {
            this.getChangeFirstMenu(selectedFirstLevelMenu);
        }
        else {
            const dishesSort = getSettingInfo('menu-dishes-sort', 'value');
            let menuTarget = await DefaultRequest.getMenusItem(selectedFirstLevelMenu.main_group_id, dishesSort);
            if (Array.isArray(menuTarget)) this.getChangeFirstMenu(menuTarget[0]);
        }
    }

    /**
     * 根据切换的一级菜单
     * @param menu
     */
    getChangeFirstMenu(menu: Menu) {
        try {
            if (menu) {
                menu.menu_item_slu.forEach(n => {
                    let s = n.menu_item
                    n.menu_item = s.filter(n => n.item_type === 0 || n.item_type === 3)
                })
                // 获取选中的二级菜单的菜品的图片
                let menuDish = this.getMenuDish(menu.menu_item_slu[0].menu_item).menuDish;
                // 更新缓存中的图片加载随机数参数
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'imgRandomNumberParam',
                    value: Math.random() * 100000,
                });
                this.setState({
                    // 选中的一级菜单
                    selectedFirstLevelMenu: menu,
                    //选中的一级菜单的二级菜单
                    secondLevelMenu: this.initDish(menu.menu_item_slu),
                    //选中的二级菜单的菜品
                    menuDish,
                    arrowDirection: 'DOWN',
                    recordMenuIndex: 0
                }, () => {
                    this.getHeightList();
                })
                // 菜品卡片是否次更新
                this.swiperCardViewUpdate = true;
                Store.dispatch({
                    type: 'SET',
                    path: 'selectedFirstLevelMenu',
                    value: menu
                })
            }
        } catch (error) {

        }
    }


    // 点击二级菜单
    clickSecondLevelMenu = (e: any, secondLevelMenu: SecondMenu, index: number, type?: string) => {
        try {
            this.setState({
                recordMenuIndex: index
            })
            this._onScrollToRowChange(index);
        } catch (error) {
            console.log(error, '切换二级菜单失败！');
        }
    }

    // 打开菜品大图
    openMenuDetail = (initialSlide: number, menuDish?: Array<MenuDish & { history_num?: number }>) => {
        if (menuDish) {
            // 获取选中的二级菜单的菜品的图片
            let newMenuDish = this.getMenuDish(menuDish).menuDish;
            this.setState({
                //选中的二级菜单的菜品
                menuDish: newMenuDish,
                foodDetailVisible: true,
                initialSlide,
            })
        }
        else {
            this.setState({
                foodDetailVisible: true,
                initialSlide,
            })
        }
    }

    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity = async (dish: MenuDish, type: UPGRADE, expandDish?: MenuDish) => {
        console.log(dish,'更新购物车changeMenuQuantity')
        if (type !== -1 || dish.quantity !== 0) {
            const { customer, approvalStatus } = this.props;
            if (customer === '' || customer === '0') {
                dish.customers = '1';
            } else {
                dish.customers = customer;
            }
            // 审核中
            if (approvalStatus === 'REVIEW') {
                this.messengerModule.say({
                    message: `${i18n.t('menu_page_text_under_review_wait')}`,
                    level: 'Warning',
                });
                return;
            }
            try {
                if (Number(dish.bargain_stype) === 2 && typeof(dish.bargain_num_cur) === 'number') {
                    const bargainRes = await DefaultRequest.getMenuBargainPriceItem([dish.item_id || -1]);
                    if(!bargainRes.error) {
                        // 可点数量
                        const _bargainNum = _.get(bargainRes, '[0].bargain_num_cur', 0);
                        _.set(dish, 'bargain_num_cur', _bargainNum);
                        // if(_bargainNum <= 0) return
                    }
                }
                // 服务端购物车
                ServerShoppingCart.updateServerCart({ dish, mathSymbol: type === 1 ? 0 : 1, action: { type: 0, state: 0 } });
            }
            catch (error) {
                this.messengerModule.say({
                    message: error as string,
                    level: 'Warning'
                });
            }
        }

    }

    /**
     * 切换底部导航栏模式
     * foodBarMode SINGLE 购物车模式 MULTIPLE 全部导航模式
     */
    changeFoodBarMode = () => {
        let menuTop = document.getElementById('menuTop');
        menuTop?.addEventListener('scroll', this.scrollView)
    }
    public scrollView = () => { }
    /**
     * 切换大图小图菜单模式
     */
    changeMenuDisplayMode = () => {

        this.setState(state => ({
            menuDisplayMode: state.menuDisplayMode === 'CAROUSEL' ? 'NORMAL' : 'CAROUSEL'
        }), () => {
            this.initSecondMenu();
            Store.dispatch({
                type: 'SET',
                path: 'menuModeDefaultVal',
                value: this.state.menuDisplayMode
            })
            this.getMenuListheight();
            this.getHeightList();
            this.setState({
                recordMenuIndex: 0
            })
            this.changeMenuValueIndex(0);
            // 精简版不需要以下处理
            if (this.props.liteMode) return;
            let menuTop = document.getElementById('menuTop') || { scrollTop: 0 };
            menuTop.scrollTop = 0;
        })
    }

    // 更新状态
    updateValue = (val: any) => {
        this.setState(val)
    }

    public tipRender() {
        const { approvalStatus, resendOrderSecond, customer } = this.props;
        return (
            <React.Fragment >
                {/* 弹出框 */}
                {
                    approvalStatus !== 'NO' &&
                    <FoodTip
                        approvalStatus={approvalStatus}
                        resendOrderSecond={resendOrderSecond}
                    />
                }
                {
                    (approvalStatus === 'NO' && customer.length === 0) &&
                    <SelectCustomId />
                }
            </React.Fragment >
        )
    }
    /**
     * 获取菜品分类title的高度,并初始化滚动插件
     */
    getHeightList() {
        let newlistHeight: Array<number> = [];
        let height = 0;
        newlistHeight.push(height);
        this.initSecondMenu();
        this.state.secondLevelMenu.forEach((item) => {
            if (this.state.menuDisplayMode === 'NORMAL') {
                height += Math.ceil((item?.menu_item?.length || 0) / 2) * 316 + 42;
            } else {
                height += (item?.menu_item?.length || 0) * (140 + 16) + 42;
            }
            newlistHeight.push(height);
        })
        this.setState({
            listHeight: newlistHeight
        }, () => {
            // 滚动最顶
            this._onScrollToRowChange(0);
            if (this.state.menuDisplayMode === 'NORMAL') {
                // 滚到最左
                this.changeMenuValue(0);
            }
        })
    }
    /**
     * 初始化二级菜单滚动
     */
    initSecondMenu() {
        this.SlideScroll?.refresh();
        this.SlideScroll?.scrollTo(0, 0);
        this.SlideScroll?.destroy();
        this.SlideScroll = undefined;
        const menuDisplayMode = this.state.menuDisplayMode;
        const slideWrapper: any = document.querySelector(menuDisplayMode === 'NORMAL' ? '#secondLevelMenuID' : '#menuLeftBarID');
        if (slideWrapper) {
            this.SlideScroll = new BScroll(slideWrapper, {
                scrollX: menuDisplayMode === 'NORMAL',
                scrollY: menuDisplayMode !== 'NORMAL',
                mouseWheel: true,
                click: true
            })
            this.SlideScroll?.refresh();
        }
    }

    /**
     * 改变选中菜单
     * - scrollY
     */
    changeMenuValue(scrollY: number) {
        try {
            let scrollIndex: number;
            const { listHeight } = this.state;
            scrollIndex = _.sortedIndex(listHeight, scrollY) - 1;
            scrollIndex = scrollIndex < 0 ? 0 : scrollIndex;
            this.changeMenuValueIndex(scrollIndex);
        } catch (error) { }
    }
    /**
     * 改变选中菜单
     * - scrollIndex
     */
    changeMenuValueIndex(scrollIndex: number) {
        const menuDisplayMode = this.state.menuDisplayMode;
        const wrapper: Element | null = document.querySelector(menuDisplayMode === 'NORMAL' ? '#secondLevelMenuID' : '#menuLeftBarID');
        const contentList = wrapper?.getElementsByClassName(menuDisplayMode === 'NORMAL' ? 'menu-second' : 'left-bar-item');
        try {
            if (contentList) {
                // scrollToElement 需要HTMLElement，这里获取到的是Element数组
                const el: any = contentList[scrollIndex];
                if (scrollIndex !== this.state.recordMenuIndex) {
                    this.setState({ recordMenuIndex: scrollIndex })
                    if (el) {
                        if (menuDisplayMode === 'CAROUSEL') {
                            this.SlideScroll?.scrollToElement(el, 300, 0, -10);
                        } else {
                            this.SlideScroll?.scrollToElement(el, 300, -20, 0);
                        }
                    }
                }
            }
        } catch (error) { }
    }

    _rowRenderer({ index, key, style }: any) {
        const menuDisplayMode = this.state.menuDisplayMode;
        const flatSecondLevelMenu = this.flatSecondLevelMenu();
        const item: any = flatSecondLevelMenu[index];
        const isTitle = item && _.has(item, 'title_name');
        const lastIndex = index === flatSecondLevelMenu.length - 1;
        let cacheGuidePageHideCard = StateManager.getFromCache('guidePageHideCard');
        return (
            <div key={key} style={style} >
                {menuDisplayMode === 'NORMAL'
                    ? <>
                        <div className='secondLevelMenuListBox animate-fadeIn' key={index}>
                            <Skeleton delay={0} style={{ width: '98%', margin: 2 }}>
                                {isTitle ? <div className='secondLevelMenuListBoxTitle'>
                                    <span>{_.get(item, 'title_name')}</span>
                                    {
                                        this.onGetMenuLimitFlag(Number(item.category_order_limit)) ?
                                        null
                                        :
                                        <div className={`menu-second-limit-nums 
                                        ${this.state.recordMenuIndex ? 'menu-second-limit-nums-active' : ''} 
                                        `}
                                        >
                                            {`${item.ordered_dishes_number} / ${item.customers_category_order_limit}`}
                                        </div>
                                    }
                                </div> : <></>}
                            </Skeleton>
                            <Skeleton delay={0} style={{ width: '98%', margin: 2 }}>
                                {!isTitle ? <FoodNormal
                                    key={key}
                                    liteMode={this.props.liteMode}
                                    customer={this.props.customer}
                                    menuDish={item as MenuDish[] || []}
                                    changeMenuQuantity={this.changeMenuQuantity}
                                    openMenuDetail={(eIndex) => {
                                        if (item && Array.isArray(item)) {
                                            let dishItem = item[eIndex];
                                            this.getCurrentMenuDetail(dishItem);
                                        }
                                    }}
                                    openSetDishDetail={(eIndex) => {
                                        if (item && Array.isArray(item)) {
                                            let dishItem = item[eIndex];
                                            this.getCurrentSetDishDetail(dishItem);
                                        }
                                    }}
                                    showTip={index === 1}
                                    cacheGuidePageHideCard={cacheGuidePageHideCard}
                                    currency_name={this.currency_name}
                                /> : <></>}
                            </Skeleton>
                        </div>
                        {lastIndex ? <div style={{ height: '58px', width: '100%' }}></div> : null}
                    </>
                    : <>
                        <div className='leftBarSecondLevelMenuListBox animate-fadeIn' key={index}>
                            {isTitle && <div className='secondLevelMenuListBoxTitle'>
                                <span>{_.get(item, 'title_name')}</span>
                                {
                                    this.onGetMenuLimitFlag(Number(item.category_order_limit)) ?
                                    null
                                    :
                                    <div className={`menu-second-limit-nums 
                                    ${this.state.recordMenuIndex ? 'menu-second-limit-nums-active' : ''} 
                                    `}
                                    >
                                        {`${item.ordered_dishes_number} / ${item.customers_category_order_limit}`}
                                    </div>
                                }                                            
                                </div>
                            }
                            {!isTitle &&
                                <LeftBarDishItem
                                    liteMode={!!this.props.liteMode}
                                    item={item as MenuDish}
                                    changeMenuQuantity={this.changeMenuQuantity}
                                    openMenuDetail={() => {
                                        this.getCurrentMenuDetail(item)
                                    }}
                                    openSetDishDetail={() => {
                                        this.getCurrentSetDishDetail(item);
                                    }}
                                    currency_name={this.currency_name}
                                />
                            }
                        </div>
                        {lastIndex ? <div style={{ height: '58px', width: '100%' }}></div> : null}
                    </>}
            </div>
        );
    }
    /**
     * 获取当前菜品详情
     * @param dishItem
     */
    getCurrentMenuDetail(dishItem: MenuDish) {
        const secondLevelMenu = this.state.secondLevelMenu || [];
        // 找到当前所在二级菜单
        let currentMenuDishItem = _.find(secondLevelMenu, (n) => n.dmi_slu_id === dishItem.dmi_slu_id)?.menu_item || [];
        // 找到当前所在二级菜单的菜品
        let dishIndex = _.findIndex(currentMenuDishItem, (n) => n.item_id === dishItem.item_id);
        this.openMenuDetail(dishIndex || 0, currentMenuDishItem);
    }

    /**
     * 打开套餐详情弹窗
     */
    getCurrentSetDishDetail(dishItem: MenuDish) {
        // isBusinessTime 为true则不在营业时间内
        const isBusinessTime = Store.getState().isBusinessTime;
        if (dishItem.item_type === 3 && (!isBusinessTime || dishItem.not_joining_global_limit === 1)) {
            this.setState({
                setDishItemVisible: true,
                selectedSetDishItem: dishItem
            })
        }
    }

    /**
     * 列表滚动时触发
     */
    _onScroll(position: { clientHeight: number, scrollHeight: number, scrollTop: number }) {
        if (!this.scrollLock) {
            this.changeMenuValue(Math.abs(Math.round(position.scrollTop)));
        }
        // 滑动到顶部
        if (position.scrollTop === 0) {
            this.isTop = Math.random();
            setTimeout(() => {
                this.ListRef?.addEventListener('touchstart', this.topStart)
                this.ListRef?.addEventListener('touchend', this.topEnd)
            }, 300)
            return
        }
        // 滑动到底部
        if (Math.ceil(position.scrollTop) + Math.ceil(position.clientHeight) >= position.scrollHeight) {
            this.isBottom = Math.random();
            setTimeout(() => {
                this.ListRef?.addEventListener('touchstart', this.bottomStart)
                this.ListRef?.addEventListener('touchend', this.bottomEnd)
            }, 300)
            return
        }
        this.isTop = 0;
        this.isBottom = 0;
        this.topNumber = -1;
    }



    /**
     * 跳转到二级菜单title
     */
    _onScrollToRowChange(value: number) {
        this.scrollLock = true;
        this.AutoSizerRef?.recomputeGridSize();
        this.AutoSizerRef?.scrollToPosition(this.state.listHeight[value || 0]);
        this.topNumber = 0;
        if (value === 0) {
            this.ListRef?.addEventListener('touchstart', this.topStart)
            this.ListRef?.addEventListener('touchend', this.topEndTow)
        } else {
            this.ListRef?.removeEventListener('touchstart', this.topStart)
            this.ListRef?.removeEventListener('touchend', this.topEndTow)
        }
        setTimeout(() => {
            this.scrollLock = false;
            this.isTop = 0;
            this.isBottom = 0;
        }, 200);
    }

    /**
     * 跳转到二级菜单title
     */
    _isRowLoaded({ index }: any) {
        const loadedRowsMap = this.state.loadedRowsMap || {};
        return !!loadedRowsMap?.[index];
    }
    _loadMoreRows({ startIndex, stopIndex }: any) {
        const loadedRowsMap = this.state.loadedRowsMap || {};

        for (var i = startIndex; i <= stopIndex; i++) {
            loadedRowsMap[i] = 1;
        }

        const timeoutId: any = setTimeout(() => {

            delete this._timeoutIdMap[timeoutId];

            for (var i = startIndex; i <= stopIndex; i++) {
                loadedRowsMap[i] = 2;
            }
            this.setState({ loadedRowsMap })

            promiseResolver();
        }, 2000);
        this._timeoutIdMap[timeoutId] = true;

        let promiseResolver: any;
        return new Promise(resolve => {
            promiseResolver = resolve;
        });
    }


    /**
     * 获取默认菜单
     * 根据新旧营业时间获取默认菜单
     * @returns
     */
    async getDefaultMenu(): Promise<number[]> {
        try {
            let defaultMenu: number[] = [];
            // 新营业时间
            if (isNewBusiness()) {
                // 从缓存中获取当前营业时间段
                let currentMenu: BusinessMenu[] = getCacheField('currentMenu');
                // 缓存中没有当前营业时间段
                if (currentMenu && currentMenu.length === 0) {
                    const result = await DefaultRequest.getBusinessHour2Project();
                    const SCHEDULE = scheduleTransform(_.get(result, '[0].value', []));
                    currentMenu = getCurrentBusinessMenu(SCHEDULE)

                }
                const curDefaultMenu = _.get(currentMenu, '[0].default_menu', '');
                // 转成number[]格式
                if (_.isEmpty(curDefaultMenu)) {
                    defaultMenu = [];
                }
                else {
                    defaultMenu = curDefaultMenu
                        .split(',')
                        .map((item: string) => Number(item));
                }
            }
            // 旧营业时间
            else {
                // 必选菜单
                defaultMenu = getSettingInfo('default-selection-menu', 'value').defaultMenu;
            }
            // 排序 从小至大
            defaultMenu.sort((a, b) => { return a - b });
            return defaultMenu
        }
        catch (e) {
            return []
        }
    }

    flatSecondLevelMenu() {
        const secondLevelMenu = this.state.secondLevelMenu;
        const menuDisplayMode = this.state.menuDisplayMode;
        if (menuDisplayMode === 'NORMAL') {
            return _.flatten((secondLevelMenu || []).map((n) => { 
                return [
                    { 
                        title_name: n.dmi_slu_name, 
                        ordered_dishes_number: n.ordered_dishes_number, 
                        customers_category_order_limit: n.customers_category_order_limit,
                        category_order_limit: n.category_order_limit,
                    },
                     ..._.chunk(n.menu_item, 2)] }));
        } else {
            return _.flatten((secondLevelMenu || []).map((n) => { return [
                { 
                    title_name: n.dmi_slu_name, 
                    ordered_dishes_number: n.ordered_dishes_number, 
                    customers_category_order_limit: n.customers_category_order_limit,
                    category_order_limit: n.category_order_limit,
                },
                ...(n.menu_item || [])] }));
        }
    }

    onReRender = () => {
        this.setState({})
    }

    /**
     * 顶部触摸开始
     */
    topStart = (e: TouchEvent) => {
        this.startY = e.changedTouches[0].pageY;
        this.saveTop = _.cloneDeep(this.isTop);
    }

    /**
     * 顶部触摸结束（一次下拉）
     */
    topEnd = (e: TouchEvent) => {
        if (!this.isTop) {
            this.ListRef?.removeEventListener('touchstart', this.topStart)
            this.ListRef?.removeEventListener('touchend', this.topEnd)
        }
        const endY = e.changedTouches[0].pageY;
        if (endY > this.startY && this.isTop && this.saveTop === this.isTop) { //向下拉
            this.scrollEnd('top');
        }
        this.saveTop = _.cloneDeep(this.isTop);
    }

    /**
     * 顶部触摸结束（两次下拉）
     */
    topEndTow = (e: TouchEvent) => {
        const endY = e.changedTouches[0].pageY;
        if (this.topNumber === -1) {
            this.ListRef?.removeEventListener('touchstart', this.topStart)
            this.ListRef?.removeEventListener('touchend', this.topEndTow)
        }
        if (endY > this.startY && this.topNumber === 0) {
            return this.topNumber++;
        }
        // 向下拉
        if (endY > this.startY && this.topNumber === 1) { 
            this.scrollEnd('top');
            this.ListRef?.removeEventListener('touchstart', this.topStart)
            this.ListRef?.removeEventListener('touchend', this.topEndTow)
        }
    }

    /**
     * 底部触摸开始
     */
    bottomStart = (e: TouchEvent) => {
        this.startY = e.changedTouches[0].pageY;
        this.saveBottom = _.cloneDeep(this.isBottom);
    }

    /**
     * 底部触摸结束
     */
    bottomEnd = (e: TouchEvent) => {
        if (!this.isBottom) {
            this.ListRef?.removeEventListener('touchstart', this.bottomStart)
            this.ListRef?.removeEventListener('touchend', this.bottomEnd)
        }
        const endY = e.changedTouches[0].pageY;
        // 向上滑
        if (endY < this.startY && this.isBottom && this.saveBottom === this.isBottom) {
            this.scrollEnd('bottom');
        }
        this.saveBottom = _.cloneDeep(this.isBottom);
    }

    /**
     * 上下滑动切换一级菜单
     * @returns 
     */
    scrollEnd = async (type: 'top' | 'bottom') => {
        const { firstLevelMenu, selectedFirstLevelMenu } = this.state;
        const index = firstLevelMenu.findIndex(item => item.main_group_id === selectedFirstLevelMenu.main_group_id);
        const newIndex = type === 'top' ? index - 1 : index + 1;
        const nextMenu = _.get(firstLevelMenu, newIndex);
        if (nextMenu) {
            this.setState({
                scrollLoading: type === 'top' ? 1 : 2
            })
            await this.clickFirstLevelMenu(nextMenu);
            this.setState({
                scrollLoading: 0
            })
            this.isTop = 0;
            this.isBottom = 0;
        }
    }

    onGetMenuLimitFlag = (limit: number)=>{
        return limit >= 999;
    }

    onHandleMessageBar = (dmo: DetailMessageObject & { isIgnoreTransI18N?: boolean }) => {
        const { message, level } = dmo;
        this.messengerModule.say({
            message: message,
            level: level
        });
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { secondLevelMenu, initialSlide, selectedFirstLevelMenu, menuDisplayMode, arrowDirection,
            firstLevelMenu, menuDish, loading, foodDetailVisible, recordMenuIndex, setDishItemVisible, selectedSetDishItem, scrollLoading, isAnimateFlag } = this.state;
        const { customer } = this.props;
        // 将一级菜单下的菜品重组
        let flatSecondLevelMenu = this.flatSecondLevelMenu();
        let cacheGuidePageHideDishes = StateManager.getFromCache('guidePageHideDishes');
        return (
            <div className='menuPage'>
                <div className={loading ? 'loading' : 'hide'}>
                    <CircularProgress color='primary' />
                </div>
                <div className={`topIcon ${menuDisplayMode === 'CAROUSEL' ? 'left-bar-top-area' : 'menu-list-top-area'}`}>
                    <div className={`displayFlex topIconLeftBox`}>
                        <div className='changeIcon'
                            // $ 不需要切换视图模式
                            // onClick={this.changeMenuDisplayMode}
                            onClick={() => this.setState(state => ({ arrowDirection: state.arrowDirection === 'DOWN' ? 'UP' : 'DOWN' }))}
                        >
                            {/* <IconButton className={menuDisplayMode === 'CAROUSEL' ? '' : 'hide'}><ViewModuleIcon/></IconButton>
                            <IconButton className={menuDisplayMode === 'CAROUSEL' ? 'hide' : ''}><AmpStoriesIcon/></IconButton> */}
                            <IconButton ><MenuBookOutlinedIcon /></IconButton>
                            {/* 占位box */}
                            {/* <GuideTooltips
                                onClose={() => {
                                }}
                                placement="top"
                                arrow
                                open={cacheGuidePageHideDishes}
                                title={i18n.t('novice_guide_text_switch_dish_mode')}
                                toopTipStyle={{
                                    popperIndex: this.state.updateToolTipStatus,
                                    width: 80,
                                }}
                            >
                                <div className='placeholder-center-box'></div>
                            </GuideTooltips> */}
                        </div>
                        {/* ClickAwayListener 组件可能会重新渲染整个组件,尽量少用 */}
                        <ClickAwayListener onClickAway={() => { }}>
                            <div className='menu' onClick={() => this.setState(state => ({ arrowDirection: state.arrowDirection === 'DOWN' ? 'UP' : 'DOWN' }))}>
                                <span className='menuText'>{selectedFirstLevelMenu.main_group_name}</span>
                                <GuideTooltips
                                    onClose={() => {
                                    }}
                                    placement="top"
                                    arrow
                                    open={cacheGuidePageHideDishes}
                                    title={i18n.t('novice_guide_text_first_menu')}
                                    toopTipStyle={{
                                        popperIndex: this.state.updateToolTipStatus,
                                        maxWidth: 95,
                                        height: 35
                                    }}
                                >
                                    <div style={{ display: 'inline-block' }}>
                                        <div className={arrowDirection === 'DOWN' ? 'arrowIcon' : 'hide'}><ExpandMoreOutlinedIcon /></div>
                                        <div className={arrowDirection === 'DOWN' ? 'hide' : 'arrowIcon'}><ExpandLessOutlinedIcon /></div>
                                    </div>
                                </GuideTooltips>
                            </div>
                        </ClickAwayListener>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {
                            !this.props.liteMode && customer.length > 0 && ServerShoppingCart.GLOBAL_SELF_ORDER_RULE &&
                            <div className='idBox'>
                                <div className='idLeft'>ID</div>
                                <div className='idRight'>
                                    {customer}
                                </div>
                            </div>
                        }
                        {/* 过敏源过滤器 */}
                        <MenuAllergenFilter
                            onReRender={this.onReRender}
                        />
                    </div>
                    <div className={arrowDirection === 'DOWN' ? 'mask maskHide' : 'mask'} onClick={() => this.setState({ arrowDirection: 'DOWN' })}>
                        <div
                            className='firstLevelMenu'
                            style={
                                PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ?
                                    { maxHeight: 'calc(100% - 65px)' } : {}
                            }
                        >
                            <Grid container spacing={0}>
                                {firstLevelMenu.map((item, index) => (
                                    <Grid item xs={12} key={index} onClick={(e) => { e.stopPropagation(); this.clickFirstLevelMenu(item) }}>
                                        <div className={`firstMenuItem ${selectedFirstLevelMenu?.main_group_id === item.main_group_id ? 'selectedFirstMenuItem' : ''}`}>
                                            <div className='firstMenuItemIcon'>
                                                <MenuBookOutlinedIcon />
                                            </div>
                                            <span className='name'>{item.main_group_name}</span>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                        </div>
                    </div>
                </div>
                <div className={menuDisplayMode === 'CAROUSEL' ? 'left-bar-menu-list-box' : 'menu-list-box'}>
                    {
                        menuDisplayMode === 'NORMAL'
                            ? <>
                                <div id='secondLevelMenuID' style={{ margin: '8px 0 12px 4px', textAlign: 'left' }}>
                                    <div className='slideContainer'>
                                        {secondLevelMenu.map((item, index) => (
                                            <div
                                                key={index}
                                                className={`swiper-slide menu-second ${index === recordMenuIndex ? 'active' : ''}`}
                                                onClick={(e) => this.clickSecondLevelMenu(e, item, index)}>
                                                <span>{item.dmi_slu_name}</span>
                                                {
                                                    this.onGetMenuLimitFlag(Number(item.category_order_limit)) ?
                                                    null
                                                    :
                                                    <div className={`menu-second-limit-nums 
                                                    ${index === recordMenuIndex ? 'menu-second-limit-nums-active' : ''} 
                                                    ${(item.customers_category_order_limit === item.ordered_dishes_number) && (index === recordMenuIndex) && isAnimateFlag ? 'menu-second-limit-nums-notice' : ''}`}
                                                    >
                                                        {`${item.ordered_dishes_number} / ${item.customers_category_order_limit}`}
                                                    </div>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* <FoodCarousel
                                    key={`${selectedFirstLevelMenu.main_group_id}${recordMenuIndex}`}
                                    liteMode={this.props.liteMode}
                                    customer={customer}
                                    menuDish={menuDish}
                                    changeMenuQuantity={this.changeMenuQuantity}
                                    menuDisplayMode={menuDisplayMode}
                                    openMenuDetail={this.openMenuDetail} /> */}
                            </>
                            : menuDisplayMode === 'CAROUSEL'
                                ?
                                <div id='menuLeftBarID' className='menu-left-bar' style={{}}>
                                    <div className='' >
                                        <div className='menu-left-bar-content'>
                                            {secondLevelMenu.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className={`left-bar-item ${index === recordMenuIndex ? 'left-bar-active' : ''}`}
                                                    onClick={(e) => this.clickSecondLevelMenu(e, item, index, 'left-bar')}
                                                >
                                                    <span>{item.dmi_slu_name}</span>
                                                    {
                                                        this.onGetMenuLimitFlag(Number(item.category_order_limit)) ?
                                                        null
                                                        :
                                                        <div className={`menu-second-limit-nums 
                                                        ${index === recordMenuIndex ? 'menu-second-limit-nums-active' : ''} 
                                                        ${(item.customers_category_order_limit === item.ordered_dishes_number) && (index === recordMenuIndex) && isAnimateFlag ? 'menu-second-limit-nums-notice' : ''}`}
                                                        >
                                                            {`${item.ordered_dishes_number} / ${item.customers_category_order_limit}`}
                                                        </div>
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                : <></>
                    }
                    {
                        <div style={{ flex: 1 }} ref={ref => this.ListRef = ref}>
                            <InfiniteLoader
                                key={this.InfiniteLoaderKey}
                                isRowLoaded={this._isRowLoaded}
                                loadMoreRows={this._loadMoreRows}
                                rowCount={flatSecondLevelMenu.length}
                            >
                                {({ onRowsRendered, registerChild }) => (
                                    <AutoSizer disableHeight >
                                        {({ width }) => (
                                            <List
                                                containerStyle={{ pointerEvents: 'auto' }}
                                                ref={refs => { this.AutoSizerRef = refs }}
                                                // ref={registerChild}
                                                onRowsRendered={onRowsRendered}
                                                onScroll={this._onScroll}
                                                height={this.MenuListHeight}
                                                overscanRowCount={1}
                                                rowCount={flatSecondLevelMenu.length}
                                                rowHeight={
                                                    ({ index }) => {
                                                        if (menuDisplayMode === 'NORMAL') {
                                                            let item = flatSecondLevelMenu[index];
                                                            if (item && isArray(item)) {
                                                                if (index === flatSecondLevelMenu.length - 1) {
                                                                    const emptyHeight = this._isIphonex ? 88 : 58;
                                                                    return 308 + emptyHeight + 8
                                                                }
                                                                return 308 + 8
                                                            }
                                                            return 42
                                                        } else {
                                                            let item = flatSecondLevelMenu[index];
                                                            if (item && !_.has(item, 'title_name')) {
                                                                if (index === flatSecondLevelMenu.length - 1) {
                                                                    return 140 + 16 + 58
                                                                }
                                                                return 140 + 16
                                                            }
                                                            return 42
                                                        }
                                                    }
                                                }
                                                rowRenderer={this._rowRenderer}
                                                width={width}
                                            />
                                        )}
                                    </AutoSizer>
                                )}
                            </InfiniteLoader>
                            {
                                scrollLoading ?
                                <div className='scroll-loading'>
                                    <CircularProgress
                                        color='primary'
                                        className='scroll-loadinging'
                                        style={scrollLoading === 1 ? { top: 10 } : { bottom: 40 }}
                                    />
                                </div>
                                :
                                null
                            }
                        </div>
                    }
                </div>

                {/* 占位盒兼容 - 需要判断手机设备类型 && Safari 浏览器 */}
                {
                    menuDisplayMode === 'NORMAL' &&
                    (() => {
                        if (isIphonex()) {
                            return (
                                < div className={PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ?
                                    'placeholder-box-iosSafeArea' : 'placeholder-box-android'} />
                            );
                        }
                        else {
                            return (
                                < div className={PHONE_TYPE.indexOf('iPhone') > -1 && PHONE_TYPE.indexOf('Safari') > -1 ?
                                    'placeholder-box-ios' : 'placeholder-box-android'} />
                            );
                        }

                    })()
                }

                {/* 菜品大图 */}
                {
                    foodDetailVisible &&
                    <FoodDetail
                        liteMode={this.props.liteMode}
                        customer={customer}
                        initialSlide={initialSlide}
                        updateValue={this.updateValue}
                        menuDish={menuDish}
                        changeMenuQuantity={this.changeMenuQuantity}
                        openSetDishDetail={(item) => this.getCurrentSetDishDetail(item)}
                    />
                }
                {
                    setDishItemVisible && selectedSetDishItem &&
                    <SetDishDetailItem
                        details={selectedSetDishItem}
                        updateValue={this.updateValue}
                        changeMenuQuantity={this.changeMenuQuantity}
                        menuItemType={this.showMenuItemType}
                        onHandleMessageBar={this.onHandleMessageBar}
                    />
                }
                {
                    !this.props.liteMode &&
                    this.tipRender()
                }
            </div >

        );
    }

}

export default withSnackbar(MenuPage);

// *********************
// Types
// *********************

type State = {
    // 一级菜单
    firstLevelMenu: Array<Menu>;
    // 选中的一级菜单
    selectedFirstLevelMenu: Menu;
    // 选中的一级菜单的二级菜单
    secondLevelMenu: Array<SecondMenu>;
    // 所有二级菜单数据
    secondLevelMenuData: Array<SecondMenu>;
    // 选中的二级菜单的菜品
    menuDish: Array<MenuDish & { history_num?: number }>;
    // 点餐模式  左轮模式 / 默认列表模式 / 空
    menuDisplayMode: 'CAROUSEL' | 'NORMAL' | 'DETAIL';
    // 一级菜单下拉箭头
    arrowDirection: 'UP' | 'DOWN';
    // 加载中
    loading: boolean;
    // 是否打开菜品大图
    foodDetailVisible: boolean;
    // 菜品大图轮播图索引
    initialSlide: number;
    // 上一轮次已点数
    turnDishesNum: number;
    // 记录每一轮的历史记录
    roundCustomerDishData: HistoryData['round_customer_dish_data'];
    updateToolTipStatus: boolean;
    // 所有一级菜单下的菜品
    dishesList: Array<MenuDish>;
    listHeight: Array<number>;
    loadedRowsMap: any;
    // 选中二级菜单的位置
    recordMenuIndex: number;
    // 显示套餐详情
    setDishItemVisible: boolean;
    // 选择的套餐
    selectedSetDishItem: MenuDish | undefined;
    // 0-隐藏，1-顶部， 1- 底部
    scrollLoading: number;
    // 
    isAnimateFlag: boolean;
}

type Props = {
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED';
    // 更新
    updateLocalState: (val: any) => void;
    //倒计时
    resendOrderSecond: number;
    // 顾客id
    customer: string;
    // 精简版模式
    liteMode?: boolean;

} & WithSnackbarProps



